"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useHls_1 = __importDefault(require("../hooks/useHls"));
var SecondVideoPreload = function (_a) {
    var sources = _a.sources;
    var videoRef = react_1.useRef(null);
    useHls_1.default({ sources: sources, videoRef: videoRef });
    return (jsx_runtime_1.jsx("video", { ref: videoRef, muted: true, style: { display: 'none' } }, void 0));
};
exports.default = SecondVideoPreload;
